import { DaoProjectItemType, DaoProposalType } from 'Modules'

import { DAO_API_ERROR_MESSAGES } from 'constants/dao-voting'

/** Message of a failed DAO admin API call - known `data.error` codes first, then the BE message */
export const daoApiErrorMessage = (error: any): string | undefined =>
  DAO_API_ERROR_MESSAGES[error?.response?.data?.data?.error] || error?.response?.data?.message

/**
 * Proposal display number per mockup ("Proposal #N — {title}"):
 * #1 is the first proposal ever created for the project.
 * project.proposals is newest-first, so the last item is #1.
 */
export const getProposalNumber = (project: DaoProjectItemType, proposal: DaoProposalType) => {
  const index = project.proposals.findIndex((p) => p._id === proposal._id)
  return index === -1 ? 0 : project.proposals.length - index
}

export const getProposalDisplayName = (project: DaoProjectItemType, proposal: DaoProposalType) =>
  `Proposal #${getProposalNumber(project, proposal)} — ${proposal.title}`

/** Two-letter initials for the project avatar (mockup style) */
export const getProjectInitials = (name: string) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean)
  if (!words.length) return '--'
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return `${words[0][0]}${words[1][0]}`.toUpperCase()
}

const AVATAR_COLORS = ['#2f54eb', '#fa8c16', '#722ed1', '#389e0d', '#595959', '#1677ff', '#c41d7f']

/** Deterministic avatar color per project name */
export const getProjectAvatarColor = (name: string) => {
  let hash = 0
  for (let i = 0; i < (name || '').length; i++) {
    hash = (hash * 31 + name.charCodeAt(i)) % 100000
  }
  return AVATAR_COLORS[hash % AVATAR_COLORS.length]
}
